import React, { useState, useEffect } from 'react';
import { CustomButton } from '../shared/customButton';
import { CustomTextField } from '../shared/customTextField';
import { Container, Row, Col, Form, Image } from 'react-bootstrap';
import styles from './EmailVerify.module.scss';
import { CustomAlertBox } from '../shared/customAlertBox';
import { verifyVerificationCode, getAccessToken, resendVerificationCode, getEmailAddress } from '../../services/util/auth';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';

const EmailVerify = (props) => {
    const [isLoading, setStatus] = useState(false);
    const [isReCodeLoading, setReCodeStatus] = useState(false);
    const [message, setMessage] = useState();
    const [show, setShow] = useState(false);
    let history = useNavigate();

    const schema = yup.object({
        code: yup.string().test('Digits only', 'The field should have digits only', (value) => /^\d+$/.test(value)).required('Required')
    });

    const formFocus = () => {
        setShow(false);
    }

    const resendCode = async () => {
        if (isReCodeLoading === false) {
            setReCodeStatus(true);
            const token = getAccessToken();
            let respond = await resendVerificationCode(token)
            if (respond.success === true) {
                setReCodeStatus(false);
            } else {
                setReCodeStatus(false);
                setMessage(respond.msg);
                setShow(true);
            }
        }

    }

    const onSubmit = async (values) => {
        setStatus(true);
        let respond = await verifyVerificationCode(values.code)
        if (respond.success === true) {
            ReactGA.event('email_verified');
            setStatus(false);
            history('/company');
        } else {
            setStatus(false);
            setMessage(respond.msg);
            setShow(true);
        }

    }

    const checkIsAccountActivated = () => {
        let isActivated = ((window.localStorage.getItem('activated')) == 'true');
        if (isActivated === true) {
            history('/company');
        }
    }

    useEffect(() => {
        checkIsAccountActivated();
        ReactGA.initialize([{
            trackingId: `${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`
        }]);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])

    return (
        <div>
            <Helmet>
                <title>Email Verify | HireTrace</title>
            </Helmet>
            <Row className={styles.mainRowSignup}>
                <Col xs={12} md={6} className={styles.leftBar}>
                    <Container>
                        <Col className={styles.topicColumn}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 40C25.4247 40 40 25.4247 40 0C40 25.4247 54.5753 40 80 40C54.5753 40 40 54.5753 40 80C40 54.5753 25.4247 40 0 40Z" fill="white" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C7.62742 12 12 7.62742 12 0C12 7.62742 16.3726 12 24 12C16.3726 12 12 16.3726 12 24C12 16.3726 7.62742 12 0 12Z" fill="#FEC84B" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M64 24C69.0849 24 72 21.0849 72 16C72 21.0849 74.9151 24 80 24C74.9151 24 72 26.9151 72 32C72 26.9151 69.0849 24 64 24Z" fill="#FEC84B" />
                            </svg>
                            <p className={styles.topicDesc}>
                                Start your Free Trial
                            </p>
                            <p className={styles.secondDesc}>Create a free account and get full access to all features for <br /> 14-days. No credit card needed. Get started in 2 minutes.</p>

                        </Col>
                        <Col className={styles.bottomColum}>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_1.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_2.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_3.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_4.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_5.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userTexteDiv}>
                                <p className={styles.bottomDesc}>Join 5,000+ Talent Professionals</p>
                            </div>

                        </Col>
                    </Container>
                </Col>
                <Col xs={12} md={6}>
                    <Container className={styles.mainContainer}>
                        <Row>
                            <Col className={styles.leftColumnMain}>
                                <div className={styles.companySecondLogoDiv}>
                                    <a href="/" target="_blank" rel="noreferrer">
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/favicon (1).ico`} rounded fluid className={styles.companyLogo} />
                                    </a>
                                </div>
                                <div className={styles.companyLogoTextDiv}>
                                    <p>Hiretrace</p>
                                </div>
                            </Col>
                            <Col className={styles.rightColumnMain}>
                                <p className={styles.rightColumnTopText}>Have an account?</p>
                                <Link to="/signin" className={styles.rightColumnTopSecondText}>
                                    Log in
                                </Link>
                            </Col>
                        </Row>
                        <Container>
                            <Row className={styles.formRow}>
                                <Col sm={10} xl={6}>
                                    <Row>
                                        <Col className='m-0 p-0'>
                                            <h3 className={styles.boxTopic}>Email Verification</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="m-0 p-0 text-left">
                                            <p><span className={styles.boxdescription}>We have sent you a 6 digit verification code to <b>{getEmailAddress() ? getEmailAddress() : null}</b>. Please enter it below.</span></p>
                                        </Col>
                                    </Row>

                                    <Row className={styles.alertRow}>
                                        <Col className={styles.alertColumn}>
                                            <CustomAlertBox alertBodyText={'Your verification email might be in spam or junk folder'} errorMessageId="emailVerify_errorMsgId" alertType='warningAlert' />
                                        </Col>
                                    </Row>
                                    {show === true &&
                                        <div className={styles.formDivRow}>
                                            {show === true ? (<CustomAlertBox alertBodyText={message} alertType='dangerAlert'/>) : ''}
                                        </div>
                                    }
                                    <Row>
                                        <Col className='p-0'>
                                            <Formik
                                                validationSchema={schema}
                                                onSubmit={(values) => onSubmit(values)}
                                                initialValues={{}}>
                                                {({
                                                    errors,
                                                    handleChange,
                                                    handleSubmit,
                                                    submitCount
                                                }) => (
                                                    <Form noValidate onSubmit={handleSubmit} onFocus={() => formFocus()}>
                                                        <Col className='m-0 p-0'>
                                                            <CustomTextField
                                                                label='6-digit verification code'
                                                                placeholder="Enter 6 Digit Code"
                                                                classLabel="defaultLabel"
                                                                controlId="code"
                                                                handleOnChange={handleChange}
                                                                name="code"
                                                                type="text"
                                                                classType="defaultTextBox"
                                                                errorMessage={errors.code}                                                              
                                                                validationMessageId="emailVerify_code_codeValidationMsgId"
                                                                isInvalid={submitCount > 0 && !!errors.code}
                                                            />
                                                        </Col>
                                                        <Col sm={12} className='mt-4 p-0'>
                                                            <CustomButton
                                                                buttonType="submit"
                                                                id="emailVerify_verifyBtnId"
                                                                label="Verify"
                                                                type="primaryBtn"
                                                                disabled={isLoading === true ? true : false}
                                                                backicon=
                                                                {isLoading === true ?
                                                                    <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                                    : ''
                                                                }
                                                            />
                                                        </Col>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </Col>
                                    </Row>
                                    <Row className={styles.resendTextRow}>
                                        <span><p className={styles.resendText}>Didn't receive?<span className={styles.resendLink} id="emailVerify_resendLinkId" onClick={() => resendCode()}>Resend {isReCodeLoading === true && <i className={`${"fas fa-spinner fa-spin"} ${styles.loadingIcon}`}></i>}</span></p></span>
                                    </Row>
                                    {/* <Row>
                                        <div className={styles.verificateNoteBBox}>
                                            <Col className="text-left mt-3">
                                                <p className={styles.spamMsg}> <svg data-tooltip-id={`KeyWordToScanInfo`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#D2A20E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> &nbsp;Please check your verification code in spam or junk email folder</p>
                                            </Col>
                                        </div>
                                    </Row> */}
                                </Col>
                            </Row>
                        </Container>
                        <Row className={styles.bottomRow}>
                            <Col>
                            </Col>
                            <Col>
                                <div className={styles.helpEmailDiv}>
                                    <p className={styles.helpText}>© Hiretrace 2024</p>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
            {/* <Row className={styles.emailVerifyBackgroundColor}>
                <Container>
                    <Row>
                        <Col xs={{ span: 10, offset: 1 }} md={{ span: 6, offset: 3 }} >
                            <div className={styles.emailVerifyBox}>
                                <Col sm={{ span: 10, offset: 1 }} className={styles.companyLogoDiv}>
                                    <a href="/" target="_blank" rel="noreferrer">
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/companylogo.png`} rounded fluid className={styles.companyLogo} />
                                    </a>
                                </Col>
                                <Container className={styles.innerBoxContainer}>
                                    <Row>
                                        <Col>
                                            <h3 className={styles.boxTopic}>Email Verification</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={{ span: 8, offset: 2 }} className="text-left">
                                            <p><span className={styles.boxdescription}>We have sent you a 6 digit verification code to <b>{getEmailAddress() ? getEmailAddress() : null}</b>. Please enter it below. Didn’t receive?&nbsp;&nbsp; </span>{isReCodeLoading === true ? <span className={styles.boxLinkDisabled}>Resend<i className={`${"fas fa-spinner fa-spin"} ${styles.loadingIcon}`}></i></span> : <span className={styles.boxLink} onClick={() => resendCode()}>Resend</span>}</p>
                                        </Col>
                                    </Row>
                                    {show === true &&
                                        <Col sm={{ span: 8, offset: 2 }}>
                                            {show === true ? (<AlertBox alertMessage={message} />) : ''}
                                        </Col>
                                    }
                                    <Formik
                                        validationSchema={schema}
                                        onSubmit={(values) => onSubmit(values)}
                                        initialValues={{}}>
                                        {({
                                            errors,
                                            handleChange,
                                            handleSubmit,
                                            submitCount
                                        }) => (
                                            <Form noValidate onSubmit={handleSubmit} onFocus={() => formFocus()}>
                                                <Col sm={{ span: 8, offset: 2 }}>

                                                    <Col sm={{ span: 8, offset: 2 }} className={styles.codeTextBox}>
                                                        <Form.Group className={styles.formText} controlId={props.controlId}>
                                                            <Form.Control
                                                                className={styles.defaultTextBox}
                                                                placeholder="Enter 6 Digit Code"
                                                                onChange={handleChange}
                                                                name="code"
                                                                type="text"
                                                                isInvalid={submitCount > 0 && !!errors.code}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.code}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>

                                                    {<CustomButton
                                                        buttonType="submit"
                                                        label="Verify"
                                                        type="primaryBtn"
                                                        disabled={isLoading === true ? true : false}
                                                        backicon=
                                                        {isLoading === true ?
                                                            <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                            : ''
                                                        }

                                                    />}

                                                </Col>
                                            </Form>
                                        )}
                                    </Formik>
                                    warning msg for check spam folder
                                    <Row>
                                        <Col sm={{ span: 8, offset: 2 }} className="text-left mt-3">
                                            <p className={styles.spamMsg}> <svg data-tooltip-id={`KeyWordToScanInfo`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#D2A20E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> &nbsp;Please check your verification code in spam or junk email folder</p>
                                        </Col>
                                    </Row>

                                </Container>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row> */}
        </div >
    )
}

export default EmailVerify;